module.exports = __webpack_public_path__ + "media/images/icon-svg/logout-d5aed2fbc0d99d0d85d492ec4f316c98.svg";